export const ElECTRON_CUSTOM_TITLEBAR_HEIGHT = 30
export const ELECTRON_WINDOWS_RADIUS = 12
